/* ==========================================================================
   TRCO Cart Drawer · part C of 4 — upsells, line/add-on changes, bubble, timer
   ========================================================================== */
(function () {
  'use strict';
  var T = window.__trco; if (!T) return;
  var CONFIG = T.CONFIG, url = T.url, formatMoney = T.formatMoney, esc = T.esc, pad = T.pad,
      sizedImg = T.sizedImg, getJSON = T.getJSON, postJSON = T.postJSON, Ctrl = T.Ctrl;

  /* ---- upsells (per-product, curated) ----------------------------------- */
  // Mapping shape: { "default": ["handle", ...], "byHandle": { "product-handle": ["handle", ...] } }
  Ctrl.prototype.loadUpsellMap = function () {
    if (this._upsellMap) return Promise.resolve(this._upsellMap);
    if (this._upsellMapPromise) return this._upsellMapPromise;
    var self = this;
    var u = CONFIG.upsellMapUrl;
    this._upsellMapPromise = (u ? fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.json(); }) : Promise.resolve({}))
      .then(function (m) { self._upsellMap = m || {}; return self._upsellMap; })
      .catch(function () { self._upsellMap = {}; return self._upsellMap; });
    return this._upsellMapPromise;
  };

  // Each item's curated list, then the default list, de-duplicated, minus anything in the cart.
  Ctrl.prototype.resolveUpsells = function (cart, map) {
    var byHandle = (map && map.byHandle) || {};
    var def = (map && map.default) || CONFIG.defaultUpsells || [];
    var inCartHandles = {};
    (cart.items || []).forEach(function (it) { if (it.handle) inCartHandles[it.handle] = true; });

    var ordered = [];
    (cart.items || []).forEach(function (it) {
      var list = byHandle[it.handle];
      if (list && list.length) ordered = ordered.concat(list);
    });
    ordered = ordered.concat(def);

    var seen = {}, result = [];
    for (var i = 0; i < ordered.length; i++) {
      var h = ordered[i];
      if (!h || seen[h] || inCartHandles[h]) continue;
      seen[h] = true;
      result.push(h);
    }
    return result.slice(0, CONFIG.maxUpsells || 6);
  };

  Ctrl.prototype.ensureUpsellProducts = function (handles) {
    var self = this;
    var toFetch = handles.filter(function (h) { return self.upsellProducts[h] === undefined; });
    return Promise.all(toFetch.map(function (h) {
      return getJSON('products/' + h + '.js').then(function (p) {
        self.upsellProducts[h] = {
          id: p.id,
          handle: p.handle,
          title: p.title,
          url: '/products/' + p.handle,
          image: (p.featured_image || (p.images && p.images[0]) || ''),
          hasVariants: !p.has_only_default_variant && (p.variants || []).length > 1,
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, price: v.price, compareAt: v.compare_at_price || null, available: v.available };
          })
        };
      }).catch(function () { self.upsellProducts[h] = null; });
    }));
  };

  Ctrl.prototype.updateUpsells = function (cart) {
    var self = this;
    this.loadUpsellMap().then(function (map) {
      var handles = self.resolveUpsells(cart, map);
      if (!handles.length) { self.upsellsEl.hidden = true; return; }
      return self.ensureUpsellProducts(handles).then(function () {
        self.renderUpsellTiles(handles);
      });
    }).catch(function () {});
  };

  Ctrl.prototype.renderUpsellTiles = function (handles) {
    var copy = CONFIG.copy || {};
    var self = this;
    var html = handles.map(function (h) {
      var u = self.upsellProducts[h];
      if (!u) return '';
      var available = u.variants.filter(function (v) { return v.available; });
      if (!available.length) return '';
      var v0 = available[0];
      var hasCompare = v0.compareAt && v0.compareAt > v0.price;

      var selector = '';
      if (u.hasVariants && u.variants.length > 1) {
        selector = '<select class="trco-upsell__select" data-trco-variant>' +
          u.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === v0.id ? ' selected' : '') + '>' + esc(v.title) + '</option>';
          }).join('') + '</select>';
      }

      var img = sizedImg(u.image, 120);
      return '' +
        '<div class="trco-upsell" data-product="' + u.id + '">' +
          '<div class="trco-upsell__media"><a href="' + esc(u.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(u.title) + '" loading="lazy">' : '') + '</a></div>' +
          '<div class="trco-upsell__info">' +
            '<a class="trco-upsell__title" href="' + esc(u.url) + '" title="' + esc(u.title) + '">' + esc(u.title) + '</a>' +
            '<div class="trco-upsell__prices">' +
              (hasCompare ? '<span class="trco-upsell__compare">' + formatMoney(v0.compareAt) + '</span>' : '') +
              '<span class="trco-upsell__price">' + formatMoney(v0.price) + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="trco-upsell__actions">' + selector +
            '<button class="trco-upsell__add" data-trco-upsell-add data-default="' + v0.id + '">' + esc(copy.addButton || 'Add') + '</button>' +
          '</div>' +
        '</div>';
    }).join('');

    if (!html.replace(/\s/g, '')) { this.upsellsEl.hidden = true; return; }
    if (html !== this._lastUpsellHTML) {
      this.upsellListEl.innerHTML = html;
      this._lastUpsellHTML = html;
    }
    this.upsellsEl.hidden = false;
  };

  Ctrl.prototype.addUpsell = function (btn) {
    var wrap = btn.closest('.trco-upsell');
    var select = wrap ? wrap.querySelector('[data-trco-variant]') : null;
    var variantId = select ? parseInt(select.value, 10) : parseInt(btn.getAttribute('data-default'), 10);
    if (!variantId) return;
    var self = this;
    btn.disabled = true;
    this.el.classList.add('is-busy');
    postJSON('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .then(function () { return self.refresh(false); })
      .then(function () { self.el.classList.remove('is-busy'); })
      .catch(function () { self.el.classList.remove('is-busy'); btn.disabled = false; });
  };

  /* ---- line changes ----------------------------------------------------- */
  Ctrl.prototype.changeLine = function (key, quantity) {
    if (!key) return;
    var self = this;
    this.el.classList.add('is-busy');
    postJSON('cart/change.js', { id: key, quantity: Math.max(0, quantity) })
      .then(function (cart) { self.cart = cart; return self.ensureCompareData(cart); })
      .then(function () { self.render(); self.el.classList.remove('is-busy'); })
      .catch(function () { self.el.classList.remove('is-busy'); });
  };

  /* ---- add-on ----------------------------------------------------------- */
  Ctrl.prototype.toggleAddon = function (on) {
    var variantId = CONFIG.addon && CONFIG.addon.variantId;
    if (!variantId) return;
    var self = this;
    this.el.classList.add('is-busy');
    var p;
    if (on) {
      p = postJSON('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
    } else {
      var line = (this.cart.items || []).filter(function (it) { return it.id === variantId || it.variant_id === variantId; })[0];
      p = line ? postJSON('cart/change.js', { id: line.key, quantity: 0 }) : Promise.resolve();
    }
    p.then(function () { return self.refresh(false); })
      .then(function () { self.el.classList.remove('is-busy'); })
      .catch(function () { self.el.classList.remove('is-busy'); });
  };

  /* ---- cart bubble ------------------------------------------------------ */
  Ctrl.prototype.updateBubble = function (count) {
    var wrap = document.querySelector('.cart-count-bubble');
    if (wrap) {
      var span = wrap.querySelector('span[aria-hidden="true"]') || wrap.querySelector('span');
      if (span) span.textContent = count;
      wrap.style.display = count > 0 ? '' : 'none';
      return;
    }
    // Bubble not yet in DOM (e.g. first item added) — build it via Dawn's section render.
    var icon = document.getElementById('cart-icon-bubble');
    if (count > 0 && icon) {
      fetch(url('?section_id=cart-icon-bubble'), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          try {
            var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
            if (fresh) icon.innerHTML = fresh.innerHTML;
          } catch (e) {}
        }).catch(function () {});
    }
  };

  /* ---- timer ------------------------------------------------------------ */
  Ctrl.prototype.timerEnd = function () {
    var minutes = CONFIG.timerMinutes || 10;
    var now = Date.now();
    var end = 0;
    try { end = parseInt(localStorage.getItem('trco_timer_end'), 10) || 0; } catch (e) {}
    if (!end || end <= now) {
      end = now + minutes * 60000;
      try { localStorage.setItem('trco_timer_end', String(end)); } catch (e) {}
    }
    return end;
  };
  Ctrl.prototype.renderTimer = function () {
    if (!this.timerTextEl) return;
    var remaining = Math.max(0, this.timerEnd() - Date.now());
    if (remaining <= 0) {
      try { localStorage.removeItem('trco_timer_end'); } catch (e) {}
      remaining = Math.max(0, this.timerEnd() - Date.now());
    }
    var total = Math.floor(remaining / 1000);
    var tmpl = (CONFIG.copy && CONFIG.copy.timer) || 'Your products are reserved for {time} minutes!';
    this.timerTextEl.textContent = tmpl.replace('{time}', pad(Math.floor(total / 60)) + ':' + pad(total % 60));
  };
  Ctrl.prototype.startTimer = function () {
    var self = this;
    this.renderTimer();
    this.stopTimer();
    this.timerInterval = setInterval(function () { self.renderTimer(); }, 1000);
  };
  Ctrl.prototype.stopTimer = function () {
    if (this.timerInterval) { clearInterval(this.timerInterval); this.timerInterval = null; }
  };
})();